import {
  MessagesInterface,
  ManagerUser,
  Project,
  CreativeType,
  ConceptType,
} from '../../../general/model';
import { BLOptions } from '../../../general/modelCreativeFolder';
import { PlotRecognitionInfo, emptyPlotRecognition } from '../../../general/modelPlotRecognition';
import { Interrupt } from '../../../general/scenarioFactory';
import { Genre, Intro } from '../../../general/apiScenarios';

export const CREATIVE_NAME_RULES = {
  SPACE: /\s+/g,
  FORBIDDEN: /[:/\\%&{}<>?*$"@+`]/g,
  HINT: ': / \\ % & { } < > ? * $ " @ + `',
};

export const spacesToDashes = (nodeName: string) => {
  return nodeName.replaceAll(CREATIVE_NAME_RULES.SPACE, '-');
};

export type CreativeFolderShape = {
  context: BLContext;
  options: WithMultipleValues<BLOptions>;
  meta: {
    isOpen: boolean;
    confirmInProgress: boolean;
    isInitialized: boolean;
    tagsNew: string[];
    tagSearchText: string;
    editableFields: (keyof BLOptions)[] | null;
    // Справочная информация о распознавании (статус, поля, зафиксированные вручную).
    // `null` — креативов выбрано несколько либо распознавания не было (MYUA-16423).
    plotRecognitionInfo: PlotRecognitionInfo | null;
  };
};

export type BLContext = {
  projects: Project[];
  creativeTypes: CreativeType[];
  tags: string[];
  genres: Genre[];
  intros: Intro[];
  conceptTypes: ConceptType[];
  user: Partial<ManagerUser>;
};

export const MultipleValuesSymbol = Symbol('<multiple values>');
export type MultipleValues = typeof MultipleValuesSymbol;
export type WithMultipleValues<T> = {
  [P in keyof T]: T[P] | MultipleValues;
};

export const initialState: CreativeFolderShape = {
  context: {
    creativeTypes: [],
    tags: [],
    genres: [],
    intros: [],
    conceptTypes: [],
    projects: [],
    user: {},
  },
  options: {
    creativeTypeId: null,
    tagsActive: [],
    genres: [],
    projectId: null,
    creativeName: '',
    managerId: null,
    developerId: null,
    manager: null,
    developer: null,
    mislead_level: null,
    teamID: null,
    intro: null,
    ai_generated: false,
    concept_type: null,
    source_creatives: null,
    plot_recognition: emptyPlotRecognition(),
  },
  meta: {
    confirmInProgress: false,
    isOpen: false,
    isInitialized: false,
    editableFields: null,
    tagsNew: [],
    tagSearchText: '',
    plotRecognitionInfo: null,
  },
};

// MYUA-16783: antd Select не работает с boolean-значениями — кодируем строками.
export const AI_GENERATED_VALUE = { ai: 'ai', notAi: 'not_ai' } as const;
export const AI_GENERATED_OPTIONS = [
  { label: 'AI', value: AI_GENERATED_VALUE.ai },
  { label: 'Not AI', value: AI_GENERATED_VALUE.notAi },
];

export enum TagsMode {
  EDIT,
  ADD,
}

export const Messages: MessagesInterface = {
  creativeLoadFailed: () => ({
    title: 'Failed to load creative data',
  }),
  creativeUpdateFailed: () => ({
    title: 'Failed to edit some creatives',
  }),
  creativeFolderScenarioError: (reason: Interrupt) => ({
    title: reason.message ?? 'Unknown error',
  }),
  createFolderError: () => ({
    title: 'Server request error',
    message: 'Creative folder has not been created',
  }),
  initModalError: () => ({
    title: 'Server request error',
    message: "Creative dialog's data has not been received",
  }),
};
